import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { ImageState } from '../../../ui/gzImageRepo/types';
import { SpinnerWidth } from '../../../ui/gzProgressSpinner/types';

export const templateRemoteShell = document.createElement('template');

templateRemoteShell.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="overlay hidden" id="loading-overlay">
        <gz-progress-spinner spinnerWidth="${SpinnerWidth.LARGE}"></gz-progress-spinner>
    </div>
    <div class="left-card">
      <div class="left-card-content">
          <gz-title fontweight="500" fontSize="16" id="remote-shell-title">Remote Shell Connection</gz-title>

          <gz-endpoint-details id="endpoint-details"></gz-endpoint-details>
      </div>
      <div id="connection-details" class="hidden connection-details">
        <gz-title id="remote-shell-connection-info" class="connection-details-title" fontSize="11" fontWeight="600">REMOTE SHELL CONNECTION INFO</gz-title>
        <div class="buttons-container">
           <gz-tooltip id="upload-button-tooltip">
          <gz-button
              type="outline"
              color="primary"
              buttonheight="small"
              buttonfontsize="small"
              id="upload-button"
          >
          </gz-button>
        </gz-tooltip>
        <gz-tooltip id="download-button-tooltip">
          <gz-button
              type="outline"
              color="primary"
              buttonheight="small"
              buttonfontsize="small"
              id="download-button"
          >
          </gz-button>
        </gz-tooltip>
    </div>
      </div>
      <div class="left-card-footer-buttons hidden">
          <gz-button id="end-session-button">End Session</gz-button>
      </div>
    </div>
    <div class="right-container">
        <gz-terminal id="terminal-container"></gz-terminal>
    </div>

    <div class="remote-shell-error">
      <gz-image-repo state="${ImageState.ERROR}">
          <gz-text fontSize="14" fontWeight="400" lineHeight="1.2" id="error-message" />
      </gz-image-repo>
    </div>
  </div>
`;
